import api from './api';

/**
 * Service for Deployed Hearts > Orders (Endless Health kit lifecycle).
 */
class OnDemandOrdersService {
  static async getOrders({ status, endlessStatus } = {}) {
    return api.get('/ondemand/orders', { status, endlessStatus });
  }

  // Creates the Endless kit order for a paid storefront order (ships the kit).
  static async createKit(id) {
    return api.post(`/ondemand/orders/${id}/create-kit`);
  }

  // Pulls latest status + results from Endless (manual refresh / webhook fallback).
  static async syncOrder(id) {
    return api.post(`/ondemand/orders/${id}/sync`);
  }

  static async listWebhooks() {
    return api.get('/ondemand/endless/webhooks');
  }

  static async registerWebhook({ replace = false } = {}) {
    return api.post('/ondemand/endless/webhooks', { replace });
  }

  // Pre-flight validation for bulk kit activation (which records are ready).
  static async validateKitActivation(patientIds) {
    return api.post('/ondemand/kit-activation/validate', { patientIds });
  }

  // Activate a single patient's kit (called one-at-a-time for progress).
  static async activateKit(patientId) {
    return api.post('/ondemand/kit-activation', { patientId });
  }

  // Pull latest kit results (by activation code) for the given patients.
  static async syncKitResults(patientIds) {
    return api.post('/ondemand/kit-activation/sync-results', { patientIds });
  }
}

export default OnDemandOrdersService;
